export default __webpack_public_path__ + "static/media/eth_logo_dark.829e1aae.svg";